<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CContainer fluid>
      <CToaster :autohide="3000">
        <template v-for="info in infoList">
          <CToast :key="info.id" :show="true" :header="info.header" :color="info.color">
            {{ info.message }}
          </CToast>
        </template>
      </CToaster>

      <CRow class="justify-content-center">
        <CCol md="8" lg="6">
          <CCard class="mx-4 mb-0 text-center">
            <CCardBody class="p-5">
              <!-- Visual cue for resetting password -->
              <CIcon name="cil-lock-unlocked" size="4xl" class="mb-4 text-marketing-primary" />

              <!-- Main Heading and Instructions -->
              <h2 class="mb-3 text-marketing-primary">Reset your password</h2>
              <p class="text-muted mb-4">Enter your new password below to reset your account password.</p>

              <!-- Password Input Fields -->
              <CForm class="mb-3">
                <CInput
                  label="New password *"
                  type="password"
                  autocomplete="new-password"
                  v-model="password"
                  :disabled="loading"
                  class="mb-3 border-marketing-primary text-left"
                  :is-valid="passwordError ? false : null"
                  :invalid-feedback="passwordError"
                />

                <CInput
                  label="Confirm new password *"
                  type="password"
                  autocomplete="new-password"
                  v-model="passwordConfirmation"
                  :disabled="loading"
                  class="mb-3 border-marketing-primary text-left"
                  :is-valid="confirmError ? false : null"
                  :invalid-feedback="confirmError"
                />

                <!-- Submit Button -->
                <CButton class="mb-3 btn-marketing-accent" :disabled="loading" @click.prevent="resetPassword">
                  <CSpinner v-if="loading" size="sm" /> Reset password
                </CButton>
              </CForm>

              <!-- Link to Go Back to Login Page -->
              <p class="mt-4">
                <router-link to="/login" class="text-marketing-accent font-weight-bold">Back to log in</router-link>
              </p>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

export default {
  name: "ResetPassword",
  data() {
    return {
      loading: false,  // Loading state
      success: false,
      password: "",
      passwordConfirmation: "",
      infoList: [],  // Toast messages list
      passwordError: "",
      confirmError: "",
    };
  },
  methods: {
    navigateTo(path) {
      this.$router.push({ path: path });
    },

    resetPassword() {
      // Basic validation for empty fields
      this.passwordError = this.password ? "" : "Enter a new password";
      this.confirmError = !this.passwordConfirmation
        ? "Type the new password again"
        : this.password !== this.passwordConfirmation
          ? "The two passwords don't match. Type them again"
          : "";
      if (this.passwordError || this.confirmError) return;

      // Extract token and email from the route query
      const token = this.$route.query.token;
      const email = this.$route.query.email;

      // Prepare DTO for the API call
      const verifyDto = {
        email: email,
        token: token,
        password: this.password,
        cPassword: this.passwordConfirmation,
      };

      // Set loading state
      this.loading = true;

      // API call to reset password
      auth
        .resetPassword(verifyDto)
        .then((response) => {
          this.loading = false;
          this.toast('Success', 'Password reset. You can now log in', 'success');
          this.password = "";
          this.passwordConfirmation = "";
        })
        .catch(({ data }) => {
          this.loading = false;
          console.error(data);
          this.toast("Error", "Couldn't reset your password. " + helper.getErrorMessage(data), "danger");
        })
        .finally(() => {
          this.loading = false;
        });
      
    },

    toast(header, message, color) {
      this.infoList.push({
        id: Date.now() + Math.random(),
        header: header,
        message: message,
        color: color,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-icon {
  margin-bottom: 1rem;
}
</style>
